import {
  getUrlQuestionText,
  isUrlQuestionText,
  URL_QUESTION_TEXT,
} from '@/shared-project';

/**
 * Supports URL questions saved before localized text became canonical in the
 * database. New localized values deliberately pass through unchanged.
 */
export function resolveLegacyUrlQuestionText(
  text: string | null | undefined,
  language: string | null | undefined
): string {
  return text === URL_QUESTION_TEXT
    ? getUrlQuestionText(language)
    : (text ?? '');
}

/**
 * A URL question is never narrated from `textForVoice` — its prompt is the
 * question text itself. Legacy rows still hold the English default and are
 * translated here; rows already localized are spoken as stored.
 */
export function resolveLegacyUrlQuestionTranscript(
  text: string | null | undefined,
  transcript: string | null | undefined,
  language: string | null | undefined
): string | null {
  if (text === URL_QUESTION_TEXT) return getUrlQuestionText(language);
  if (isUrlQuestionText(text)) return text ?? null;
  return transcript ?? null;
}
